<template>
  <div class="edit__form-list">
    <div class="edit__form">
      <label class="edit__form-label">コード</label>
      <div class="edit__form-input">
        <input type="text" name="data_format_rule[code]" v-model="dataFormatRule.code" id="DataFormatRuleCode" class="" />
        <small class="edit__form-explain">半角英数字・-(ハイフン)・_(アンダースコア)</small>
      </div>
    </div>

    <div class="edit__form">
      <label class="edit__form-label">名称</label>
      <div class="edit__form-input">
        <input type="text" name="data_format_rule[name]" v-model="dataFormatRule.name" id="DataFormatRuleName" class="" />
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <div class="edit__form">
      <label class="edit__form-label">取引先</label>
      <div class="edit__form-input">
        <select name="data_format_rule[supplier_id]" v-model="dataFormatRule.supplier_id" id="DataFormatRuleSupplierId" class="">
          <option value=""></option>
          <option v-for="(name, id) in supplierList" :key="id" :value="id">{{ name }}</option>
        </select>
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <div class="edit__form">
      <label class="edit__form-label">説明</label>
      <div class="edit__form-input">
        <textarea name="data_format_rule[explain]" v-model="dataFormatRule.explain" id="DataFormatRuleExplain" class=""></textarea>
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <div class="edit__form">
      <label class="edit__form-label">プレビューフラグ</label>
      <div class="edit__form-input">
        <select name="data_format_rule[preview_flg]" empty="" v-model="dataFormatRule.preview_flg" id="DataFormatRulePreviewFlg" class="">
          <option value=""></option>
          <option v-for="(label, key) in enumFlg" :key="key" :value="key">{{ label }}</option>
        </select>
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <h2>入力フォーマット</h2>

    <div class="edit__form">
      <label class="edit__form-label">入力形式</label>
      <div class="edit__form-input">
        <select name="data_format_rule[input_file_div]" v-model="dataFormatRule.input_file_div" id="DataFormatRuleInputFileDiv" class="">
          <option value=""></option>
          <option v-for="(label, key) in enumInputFileDiv" :key="key" :value="key">{{ label }}</option>
        </select>
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <div class="input-format">
      <div class="input-format-header">
        <div></div>
        <div>タイトル</div>
        <div>形式</div>
        <div><button class="edit__submit-button--small" @click.prevent="addInputList">追加</button></div>
      </div>
      <div class="input-format-body" v-for="(item, index) in dataFormatRule.input_json" :key="index">
        <div class="input-format-body-row">
          <div class="drag-icon" :draggable="true" @dragstart="inputDragStart(index)" @dragenter="inputDragEnter(index)" @dragend.stop.prevent="inputDragEnd" @dragover.stop.prevent="inputDragOver">
            <i class="fa-solid fa-bars"></i>
          </div>
          <div class="edit__form-input"><input type="text" :name="'data_format_rule[input_json][' + index + '][title]'" v-model="item.title" /></div>
          <div class="edit__form-input">
            <select :name="'data_format_rule[input_json][' + index + '][type]'" v-model="item.type">
              <option value="STRING">文字列</option>
              <option value="NUMBER">数値</option>
              <option value="DATE">日付</option>
            </select>
          </div>
          <div><button class="edit__delete-button--small" @click.prevent="deleteInputItem(index)">削除</button></div>
        </div>

        <div class="input-format-body-row-option">
          <label>説明 :</label>
          <div class="edit__form-input flex-column">
            <input type="text" :name="'data_format_rule[input_json][' + index + '][explain]'" v-model="item.explain" />
          </div>
        </div>
      </div>
    </div>

    <input type="hidden" name="data_format_rule[filter_json]" value="[]" id="DataFormatRuleFilterJson" class="" />

    <h2>出力フォーマット</h2>

    <div class="edit__form">
      <label class="edit__form-label">出力形式</label>
      <div class="edit__form-input">
        <select name="data_format_rule[output_file_div]" v-model="dataFormatRule.output_file_div" id="DataFormatRuleOutputFileDiv" class="">
          <option value=""></option>
          <option v-for="(label, key) in enumOutputFileDiv" :key="key" :value="key">{{ label }}</option>
        </select>
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <div class="edit__form" v-show="false">
      <label class="edit__form-label">帳票テンプレート</label>
      <div class="edit__form-input">
        <label for="DataFormatRuleExcelTemplateFile" class="edit__form-upload-button">ファイルアップロード</label>
        <input type="file" @change="uploadTenantMasterFile($event)" id="DataFormatRuleExcelTemplateFile" hidden />
        <a id="DataFormatRuleExcelTemplateFileName" class="edit__form-upload-filename" :href="'/tenant_file/download/' + excelTemplateFile.id">{{ excelTemplateFile.filename }}</a>
        <input type="hidden" id="DataFormatRuleExcelTemplateFileId" name="data_format_rule[excel_template_file_id]" v-model="excelTemplateFile.id" />
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <div class="edit__form">
      <label class="edit__form-label">出力ファイル名</label>
      <div class="edit__form-input">
        <input type="text" name="data_format_rule[output_filename]" v-model="dataFormatRule.output_filename" id="DataFormatRuleOutputFilename" class="" />
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <div class="output-format">
      <div class="output-format-header">
        <div></div>
        <div>タイトル</div>
        <div>形式</div>
        <div>値</div>
        <div><button class="edit__submit-button--small" @click.prevent="addOutputList">追加</button></div>
      </div>
      <div class="output-format-body" v-for="(item, index) in dataFormatRule.output_json" :key="index">
        <div class="output-format-body-row">
          <div class="drag-icon" :draggable="true" @dragstart="outputDragStart(index)" @dragenter="outputDragEnter(index)" @dragend.stop.prevent="outputDragEnd" @dragover.stop.prevent="outputDragOver">
            <i class="fa-solid fa-bars"></i>
          </div>
          <div class="edit__form-input"><input type="text" :name="'data_format_rule[output_json][' + index + '][title]'" v-model="item.title" /></div>
          <div class="edit__form-input">
            <select :name="'data_format_rule[output_json][' + index + '][type]'" v-model="item.type">
              <option value="REFERENCE">入力列参照</option>
              <option value="FIXED">固定値</option>
              <option value="MASTER">マスタ参照</option>
              <option value="CALCLATE">計算式</option>
            </select>
          </div>
          <div class="edit__form-input" v-if="item.type == 'REFERENCE' || item.type == 'MASTER'">
            <select :name="'data_format_rule[output_json][' + index + '][target_column]'" v-model="item.target_column">
              <option v-for="item in dataFormatRule.input_json" :key="item.title" :value="item.title">{{ item.title }}</option>
            </select>
          </div>
          <div class="edit__form-input" v-if="item.type == 'FIXED'">
            <input type="text" :name="'data_format_rule[output_json][' + index + '][fixed_value]'" v-model="item.fixed_value" />
          </div>
          <div class="edit__form-input" v-if="item.type == 'CALCLATE'"></div>
          <div class="edit__form-input" v-if="item.type == null">&nbsp;</div>
          <div><button class="edit__delete-button--small" @click.prevent="deleteOutputItem(index)">削除</button></div>
        </div>
        <div class="output-format-body-row-option" v-if="item.type == 'CALCLATE'">
          <label>計算式 :</label>
          <div class="edit__form-input flex-column">
            <input type="text" :name="'data_format_rule[output_json][' + index + '][calculate_fomula]'" v-model="item.calculate_fomula" />
          </div>
        </div>
        <div class="output-format-body-row-master" v-if="item.type == 'MASTER'">
          <label>対象マスタ :</label>
          <div class="edit__form-input flex-column">
            <select :name="'data_format_rule[output_json][' + index + '][target_master]'" v-model="item.target_master">
              <option></option>
              <option v-for="(name, code) in masterList" :key="code" :value="code">{{ name }}</option>
            </select>
          </div>
          <div class="edit__form-input flex-column">
            <select :name="'data_format_rule[output_json][' + index + '][target_master_column]'" v-model="item.target_master_column">
              <option></option>
              <option v-for="(name, code) in masterColumn(item.target_master)" :key="code" :value="code">{{ name }}</option>
            </select>
          </div>
        </div>
        <div class="output-format-body-row-option">
          <label>説明 :</label>
          <div class="edit__form-input flex-column">
            <input type="text" :name="'data_format_rule[output_json][' + index + '][explain]'" v-model="item.explain" />
          </div>
        </div>
      </div>
    </div>

    <h2>出力方法</h2>

    <div class="edit__form">
      <label class="edit__form-label">出力方法</label>
      <div class="edit__form-input">
        <select name="data_format_rule[output_type_div]" v-model="dataFormatRule.output_type_div" id="DataFormatRuleOutputTypeDiv" class="">
          <option value=""></option>
          <option v-for="(label, key) in enumOutputTypeDiv" :key="key" :value="key">{{ label }}</option>
        </select>
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <div class="edit__form" v-if="dataFormatRule.output_type_div == 2">
      <label class="edit__form-label">送信先メールアドレス</label>
      <div class="edit__form-input">
        <input type="text" name="data_format_rule[mail_to]" v-model="dataFormatRule.mail_to" id="DataFormatRuleMailTo" class="" />
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <div class="edit__form" v-if="dataFormatRule.output_type_div == 2">
      <label class="edit__form-label">送信先メールアドレス(CC)</label>
      <div class="edit__form-input">
        <input type="text" name="data_format_rule[mail_cc]" v-model="dataFormatRule.mail_cc" id="DataFormatRuleMailCc" class="" />
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <div class="edit__form" v-if="dataFormatRule.output_type_div == 2">
      <label class="edit__form-label">メール件名</label>
      <div class="edit__form-input">
        <input type="text" name="data_format_rule[mail_subject]" v-model="dataFormatRule.mail_subject" id="DataFormatRuleMailSubject" class="" />
        <small class="edit__form-explain"></small>
      </div>
    </div>

    <div class="edit__form" v-if="dataFormatRule.output_type_div == 2">
      <label class="edit__form-label">メール本文</label>
      <div class="edit__form-input">
        <textarea name="data_format_rule[mail_body]" v-model="dataFormatRule.mail_body" id="DataFormatRuleMailBody" class=""></textarea>
        <small class="edit__form-explain"></small>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.input-format {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.input-format-header {
  display: grid;
  grid-template-columns: 24px 1fr 200px 70px;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  font-weight: bold;
}
.input-format-body {
  background-color: #eee;
  padding: 0 10px;
  border: solid 1px #aaa;
  border-radius: 5px;
}
.input-format-body-row {
  display: grid;
  grid-template-columns: 24px 1fr 200px 70px;
  gap: 10px;
  font-weight: bold;
  padding: 10px 0;
  align-items: center;

  input {
    width: 100%;
  }
}
.input-format-body-row-option {
  display: grid;
  grid-template-columns: 74px 1fr 70px;
  gap: 10px;
  align-items: center;
  padding-bottom: 10px;

  label {
    font-weight: bold;
    text-align: right;
    font-size: 0.9rem;
  }
}

.output-format {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.output-format-header {
  display: grid;
  grid-template-columns: 24px 1fr 200px 200px 70px;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  font-weight: bold;
  padding: 0 10px;
}

.output-format-body {
  background-color: #eee;
  padding: 0 10px;
  border: solid 1px #aaa;
  border-radius: 5px;
}
.output-format-body-row {
  display: grid;
  grid-template-columns: 24px 1fr 200px 200px 70px;
  gap: 10px;
  font-weight: bold;
  padding: 10px 0;
  align-items: center;

  input {
    width: 100%;
  }
}
.output-format-body-row-master {
  display: grid;
  grid-template-columns: 124px 1fr 1fr 70px;
  gap: 10px;
  align-items: center;
  padding-bottom: 10px;

  label {
    font-weight: bold;
    text-align: right;
    font-size: 0.9rem;
  }
}
.output-format-body-row-option {
  display: grid;
  grid-template-columns: 124px 1fr 70px;
  gap: 10px;
  align-items: center;
  padding-bottom: 10px;

  label {
    font-weight: bold;
    text-align: right;
    font-size: 0.9rem;
  }
}
.flex-column {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.drag-icon {
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
}
</style>

<script setup>
import { ref, onMounted } from 'vue';

const dataFormatRule = ref(data.dataFormatRule);
const excelTemplateFile = ref(data.excelTemplateFile);
const enumInputFileDiv = data.enum.InputFileDiv;
const enumOutputFileDiv = data.enum.OutputFileDiv;
const enumOutputTypeDiv = data.enum.OutputTypeDiv;
const enumFlg = data.enum.flg;
const supplierList = data.supplierList;
const masterList = data.masterList;
const masterColumnDic = data.masterColumnDic;

let inputDraggingIndex;
let outputDraggingIndex;

onMounted(() => {
  if (dataFormatRule.value.input_json == undefined || dataFormatRule.value.input_json.length == 0) {
    dataFormatRule.value.input_json = [];
  }
  if (dataFormatRule.value.output_json == undefined || dataFormatRule.value.output_json.length == 0) {
    dataFormatRule.value.output_json = [];
  }

  //エラー項目を赤くする
  for (const [key, message] of Object.entries(data.errorMessages)) {
    const name = key.replace(/\.(\w+)/g, '[$1]');
    document.getElementsByName(name).forEach((element) => {
      const messageElement = document.createElement('span');
      messageElement.textContent = message;
      messageElement.classList.add('invalid-feedback');
      element.insertAdjacentElement('afterend', messageElement);
      element.classList.add('is-invalid');
    });
  }
});

const addInputList = () => {
  dataFormatRule.value.input_json.push({});
};

const deleteInputItem = (index) => {
  dataFormatRule.value.input_json = dataFormatRule.value.input_json.filter((item, i) => {
    return i !== index;
  });
};

const addOutputList = () => {
  dataFormatRule.value.output_json.push({});
};

const deleteOutputItem = (index) => {
  dataFormatRule.value.output_json = dataFormatRule.value.output_json.filter((item, i) => {
    return i !== index;
  });
};

const inputDragStart = async function (index, e) {
  inputDraggingIndex = index;
};

const inputDragEnter = async function (index) {
  if (index === inputDraggingIndex) return;

  const deleteElement = dataFormatRule.value.input_json.splice(inputDraggingIndex, 1)[0];
  dataFormatRule.value.input_json.splice(index, 0, deleteElement);
  inputDraggingIndex = index;
};

const inputDragOver = async function (e) {};

const inputDragEnd = async function (e) {
  inputDraggingIndex = null;
};

const outputDragStart = async function (index, e) {
  outputDraggingIndex = index;
};

const outputDragEnter = async function (index) {
  if (index === outputDraggingIndex) return;

  const deleteElement = dataFormatRule.value.output_json.splice(outputDraggingIndex, 1)[0];
  dataFormatRule.value.output_json.splice(index, 0, deleteElement);
  outputDraggingIndex = index;
};

const outputDragOver = async function (e) {};

const outputDragEnd = async function (e) {
  outputDraggingIndex = null;
};

const uploadTenantMasterFile = async function (event) {
  try {
    const file = event.target.files[0];
    const token = document.getElementById('CsrfToken').content;

    const form = new FormData();
    form.append('file', file);
    form.append('_token', token);

    const res = await fetch('/tenant_file/master/upload', {
      method: 'POST',
      body: form,
      credentials: 'same-origin',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        excelTemplateFile.value.id = data.file.id;
        excelTemplateFile.value.filename = data.file.filename;
      })
      .catch((error) => {
        throw new Error(`HTTP ${res.status}`);
      });
  } catch (e) {
    alert(`アップロード失敗（${e?.message || 'error'}）`);
  } finally {
    event.target.value = ''; // 同一ファイルを再選択できるように
  }
};

const masterColumn = function (targetMaster) {
  if (masterColumnDic[targetMaster] == undefined) return [];

  return masterColumnDic[targetMaster];
};
</script>
